import React from 'react';

import cn from '@/helpers/utils/classNames';

import { HeadingProps } from '../propTypes';
import { headingStyles } from '../styles';

const HeadingFive = ({ className, variant = 'primary', children, ...rest }: HeadingProps) => {
  return (
    <h3
      className={cn(
        headingStyles({
          color: variant,
        }),
        'sm:text-base md:text-[1rem] lg:text-lg xs:text-sm xxs:text-xs',
        className
      )}
      {...rest}
    >
      {children}
    </h3>
  );
};

export default HeadingFive;
